import * as React from 'react';
import './HTMLEditorForNews.css';
import { FunctionComponent } from 'react';
import { HTMLEditorQuill } from './HTMLEditorQuill';
import { AppUser } from 'Src/views/App/App';

interface Props {
  user?: AppUser;
  onTextChange: (editorState: any) => void;
  value: string;
  isEnabled: boolean;
  placeholder: string;
}

export const HTMLEditorQuillForNews: FunctionComponent<Props> = props => {
  return (
    <HTMLEditorQuill
        user={props.user}
        placeholder={props.placeholder}
        onEmailBodyChange={props.onTextChange}
        value={props.value}
        isEnabled
        isToolbarVisible={props.isEnabled}
    />
  );
};

HTMLEditorQuillForNews.displayName = 'HTMLEditorQuillForNews';
